import { render } from "./EdreaPopup.vue?vue&type=template&id=8ecd2432"
import script from "./EdreaPopup.vue?vue&type=script&lang=js"
export * from "./EdreaPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__